import React, { useState, useEffect } from 'react';
import { api } from '../api/models';
import BotControls from './BotControls';
import BotLogs from './BotLogs';

export default function Editor() {
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [content, setContent] = useState("");

    useEffect(() => {
        api.getFiles().then(data => setFiles(data.files));
    }, []);

    const loadFile = async (id) => {
        const data = await api.getFile(id);
        setSelectedFile(id);
        setContent(data.content);
    };

    const saveFile = async () => {
        await api.saveFile(selectedFile, content);
        alert("💾 File salvato con successo!");
    };

    // Stili riutilizzabili
    const cardStyle = {
        background: '#1e293b',
        padding: '20px',
        borderRadius: '12px',
        border: '1px solid #334155',
        marginBottom: '20px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.2)'
    };

    // --- STILI INLINE ---
    const pageWrapperStyle = {
        backgroundColor: '#0f172a', // Sfondo scuro profondo (Slate 900)
        minHeight: '100vh',        // Copre tutta l'altezza della pagina
        width: '100%',
        margin: 0,
        padding: '40px 0',
        color: '#f1f5f9',
        fontFamily: "'Inter', system-ui, sans-serif",
    };

    const buttonFileStyle = (isActive) => ({
        backgroundColor: isActive ? '#3b82f6' : '#334155',
        color: 'white',
        border: 'none',
        padding: '8px 15px',
        margin: '5px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'all 0.2s'
    });

    const saveButtonStyle = {
        backgroundColor: '#10b981',
        color: 'white',
        border: 'none',
        padding: '12px 25px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: '600',
        marginTop: '15px',
        width: '100%'
    };

    return (
        <div style={pageWrapperStyle}>
        <div style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 20px', color: '#f1f5f9', fontFamily: 'Inter, sans-serif' }}>
            <header style={{ marginBottom: '30px', borderBottom: '2px solid #334155', paddingBottom: '10px' }}>
                <h1 style={{ margin: 0, color: '#60a5fa' }}>⚡ Light Boost Admin</h1>
                <p style={{ color: '#94a3b8', fontSize: '14px' }}>Gestione remota del bot e configurazioni</p>
            </header>

            {/* Sezione Controlli Bot */}
            <div style={cardStyle}>
                <h3 style={{ marginTop: 0, fontSize: '18px', borderBottom: '1px solid #334155', paddingBottom: '10px' }}>⚙️ Stato Servizio</h3>
                <BotControls />
                <BotLogs />
            </div>

            {/* Selezione File */}
            <div style={cardStyle}>
                <h3 style={{ marginTop: 0, fontSize: '18px' }}>📂 File di Configurazione</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {files.map(f => (
                        <button 
                            key={f} 
                            style={buttonFileStyle(selectedFile === f)} 
                            onClick={() => loadFile(f)}
                        >
                            {f}
                        </button>
                    ))}
                </div>
            </div>

            {/* Editor di Testo */}
            {selectedFile && (
                <div style={cardStyle}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h3 style={{ margin: 0 }}>📝 Editor: <span style={{ color: '#60a5fa' }}>{selectedFile}</span></h3>
                    </div>
                    
                    <textarea 
                        value={content} 
                        onChange={(e) => setContent(e.target.value)}
                        style={{
                            width: '100%',
                            backgroundColor: '#0f172a',
                            color: '#e2e8f0',
                            border: '1px solid #475569',
                            borderRadius: '8px',
                            padding: '15px',
                            fontFamily: '"Fira Code", monospace',
                            fontSize: '14px',
                            lineHeight: '1.5',
                            outline: 'none',
                            boxSizing: 'border-box'
                        }}
                        rows={30}
                    />
                    
                    <button 
                        style={saveButtonStyle} 
                        onClick={saveFile}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#059669'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#10b981'}
                    >
                        Salva Modifiche
                    </button>
                </div>
            )}
        </div>
        </div>
    );
}